//Built-in libraries

import { TrashIcon } from '@heroicons/react/24/outline';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
//Third party libraries
import * as Yup from 'yup';
//Services
import goalTotalPercentage from '../../../../utils/project';
//Custom components
import Button from '../../../UI/Button';
import { HookInput } from '../../../UI/HookForm/Form/Input';
import HookMaskedInput from '../../../UI/HookForm/Form/MaskedInput';

export const projectSocialGoalsValidationSchema = Yup.object({
  goals: Yup.array().of(
    Yup.object({
      name: Yup.string().required('This is required'),
      percentage: Yup.number()
        .required('This is required')
        .min(0, 'Amount must be 0 or greater')
        .max(100, 'This cannot be greater than 100%'),
    })
  ),
});

const ProjectSocialGoalsHookFieldArray = () => {
  const { trigger, getValues } = useFormContext();
  const { fields, append, remove } = useFieldArray({ name: 'goals' });
  const projectSocialGoalsFormValues = useWatch({ name: 'goals' });
  const totalPercentage = goalTotalPercentage(projectSocialGoalsFormValues);

  const addNewSocialGoal = async () => {
    const projectSocialGoalsValidation = await trigger('goals');
    if (projectSocialGoalsValidation || getValues('goals').length === 0) {
      append({ name: '', percentage: null });
    }
  };
  return (
    <>
      {fields.length <= 0 && <p className='text-sm text-tertiaryColor-normal'>There are no social goals added into the project.</p>}
      {fields.map((goals, idx) => (
        <div key={goals.id} className='flex justify-between gap-4 my-2'>
          <div className='grid grid-cols-2 gap-5 w-full'>
            <HookInput customClassName='col-span-1' label='Goal' name={`goals.${idx}.name` as const} id='name' type='text' />
            <HookMaskedInput
              customClassName='col-span-1'
              label='Percentage (%)'
              name={`goals.${idx}.percentage` as const}
              id='percentage'
              maskedComponent='numeric'
            />
          </div>
          <div
            className='h-full border p-2 mt-7 rounded-md text-neutralColor-normal bg-gray-50 hover:bg-tertiaryColor-lightest hover:text-tertiaryColor-normal cursor-pointer transition duration-100 ease-in-out'
            onClick={() => remove(idx)}
          >
            <TrashIcon className='h-5 w-6' />
          </div>
        </div>
      ))}
      <p className='mt-5 font-bold text-primaryColor-normal'>Total: {Number.isNaN(totalPercentage) ? 0 : totalPercentage} %</p>
      {totalPercentage > 100 && <span className='text-tertiaryColor-normal'>Total social goal percentage cannot be greater than 100%</span>}
      <div className='mt-4'>
        <Button label='Add Goal' btnStyle='btn-primary' btnSize='btn-sm' type='button' onClick={addNewSocialGoal} />
      </div>
    </>
  );
};

export default ProjectSocialGoalsHookFieldArray;
